import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import ChartIcon from '@material-ui/icons/InsertChartOutlined'
import BarChart from './bar-chart'
import { fetchPortalPaymentItems } from '../../../../../../api'
import { AuthContext } from '../../../../../../auth-context'
import { PreviewDocument } from '../pdf-generator'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const MarginSpacer = styled.div`
  height: 32px;
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  min-height: 400px;
  margin: 0 auto;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;

`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyRow = styled.tr`
  color: ${props => props.voided ? '#BBB' : '#333'};

  &:hover {
    background: #f4f7ff;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: .9rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: 100px;
  padding: 8px;
  position: sticky;
  top: 0;
`

const DataCell = styled.td`
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-size: .9rem !important;
  padding: 12px;
  text-align: center;
`

const AccountsTable = (props) => {
  const { user } = useContext(AuthContext)
  const [showPaymentItemsModal, updateShowPaymentItemsModal] = useState(false)
  const [paymentItemsData, updatePaymentItemsData] = useState({paymentId: null, createdAt: null, loading: false, items: [], itemCount: null,})
  const [show, setShow] = useState(false);
  const [transaction, setTransaction] = useState('');

  const handleViewIncludedAccounts = (transaction) => {
    if (!paymentItemsData.loading) {
      if (paymentItemsData.paymentId !== transaction.paymentId) {
        const matchPaymentItem = user.payments.find((obj => 
          obj.transaction_id === transaction.id
        ))

        updatePaymentItemsData({paymentId: transaction.paymentId, createdAt: transaction.createdAt, loading: true, items: [], itemCount: matchPaymentItem?.item_count,})
        fetchPortalPaymentItems(user.id, transaction.paymentId).then((res) => {
          updatePaymentItemsData({paymentId: transaction.paymentId, createdAt: transaction.createdAt, loading: false, items: res.data.items, itemCount: matchPaymentItem?.item_count,})
        })
      }
      updateShowPaymentItemsModal(true)
    }
  }

  const createViewIncludedAccountsButton = (data) => {
    if(data.paymentId === null) {
      return ''
    } else {
      return (
        <>
          <button className='inspect-button' style={{marginRight: '2px'}}onClick={() => handleViewIncludedAccounts(data)}>View Included Accounts</button>
          <button className='inspect-button' onClick={() => {setShow(true); setTransaction(data)}}>View Invoice</button>
        </>
      )
    }
  }

  const handleClose = () => {
    updateShowPaymentItemsModal(false)
  }

  let transactionsReverse = user.transactions.slice(0).reverse()

  return (
    <>
      <Container className={props.className}>
        <Label>
          <ChartIcon /> Payment History
        </Label>
        <BarChart />
        <MarginSpacer />
        <MarginSpacer />
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <HeadCell bigWidth>Date</HeadCell>
                <HeadCell>Amount</HeadCell>
                <HeadCell>Status</HeadCell>
                <HeadCell>Details</HeadCell>
                <HeadCell>Action</HeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {transactionsReverse.map((transaction, index) => 
                <TableBodyRow voided={transaction.status === 'voided'} key={index}>
                  <DataCell number>{moment.utc(transaction.createdAt).format('MMM D, YYYY')}</DataCell>
                  <DataCell number>{transaction.type === 'credit' && '-'} ${transaction.amount}</DataCell>
                  <DataCell>{transaction.status}</DataCell>
                  <DataCell>{transaction.processorResponseText}</DataCell>
                  <DataCell>{createViewIncludedAccountsButton(transaction)}</DataCell>
                </TableBodyRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog className='weigh-in-dialog' maxWidth="lg" fullWidth={true} open={showPaymentItemsModal} onClose={handleClose}>
          <DialogContent className='avn-modal-content-container' style={{overflowY: 'visible'}}>
            <div className='avn-modal-header-container' style={{alignItems: 'center'}}>
              <h2 style={{textTransform: 'none'}}>Accounts Included in {moment.utc(paymentItemsData.createdAt).format('MMM D, YYYY')} Payment</h2>
              <h4 style={{textTransform: 'none', textAlign: 'center', margin: '8px 0px'}}>Highest number of clients this month was {paymentItemsData.itemCount}</h4>
            </div>
            {paymentItemsData.loading ? (
              <CircularProgress size={32} />
            ) : (
              <Table>
                <TableHead>
                  <TableHeadRow>
                    <HeadCell>Name</HeadCell>
                    <HeadCell>Email</HeadCell>
                    <HeadCell>Notes</HeadCell>
                  </TableHeadRow>
                </TableHead>
                <TableBody>
                  { paymentItemsData.items.map((item, index) => {
                    let notes = ''
                    if (item.deleted_at !== null && (item.created_at === null || item.created_at < item.deleted_at)) {
                      notes = 'deleted on ' + moment.utc(item.deleted_at).format('MMM D, YYYY')
                    } else if (item.created_at !== null) {
                      notes = 'created on ' + moment.utc(item.created_at).format('MMM D, YYYY')
                    }
                    return (
                      <TableBodyRow key={index}>
                        <DataCell>{item.name}</DataCell>
                        <DataCell>{item.email_address}</DataCell>
                        <DataCell>{notes}</DataCell>
                      </TableBodyRow>
                    )
                  })}
                </TableBody>
              </Table>
            )}
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <Button style={styles.closeButton}
              onClick={handleClose}
            >
              CLOSE
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <PreviewDocument
        open={show}
        handleClose={() => setShow(false)}
        transaction={transaction}
      />
    </>
  )
}

const styles = {
  closeButton: {
    background: '#cccc',
    borderRadius: '3px',
    color: 'white',
    margin: '0 5px'
  },
}

export default AccountsTable